import { Link } from '@tanstack/react-router';
import { cn } from '@/helpers/classnames';
import { useTenantID } from '@/hooks/useTenantID';

interface TravellerNameLinkProps {
  id: string;
  name: string;
}

const TravellerNameLink = ({ id, name }: TravellerNameLinkProps) => {
  const tenantId = useTenantID();

  return (
    <Link
      to="/$tenantId/travellers/$travellerId"
      params={{ tenantId, travellerId: id }}
      className="rounded-sm font-medium underline decoration-primary-500 underline-offset-2 hover:text-primary-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600"
    >
      {name}
    </Link>
  );
};

interface BulkTravellerNamedListItem {
  id: string;
  name: string;
  detail?: string;
}

interface BulkTravellerNamedListProps {
  items: BulkTravellerNamedListItem[];
  ariaLabel: string;
  className?: string;
}

export const BulkTravellerNamedList = ({
  items,
  ariaLabel,
  className,
}: BulkTravellerNamedListProps) => {
  return (
    <ul
      className={cn(
        'max-h-56 overflow-y-auto rounded-md border border-background-200 py-1 pl-5 pr-2 text-text-700',
        className,
      )}
      tabIndex={0}
      aria-label={ariaLabel}
    >
      {items.map((item) => (
        <li key={item.id}>
          <TravellerNameLink id={item.id} name={item.name} />
          {item.detail ? ` — ${item.detail}` : ''}
        </li>
      ))}
    </ul>
  );
};
